import type { RichContent } from 'ricos-schema';

import type { DraftContent } from '../../../../types';
import { toDraft } from '../toDraft';

type TestValues = {
  type: string;
  expectedOutput: DraftContent;
  input: RichContent;
};

export const testPlugin = (describeText: string, testValues: TestValues[]) => {
  describe('To draft conversion', () => {
    describe(describeText, () => {
      it.each(testValues)('$type', ({ input, expectedOutput }) => {
        const convertedToDraft = toDraft(input);
        expect(convertedToDraft.blocks).toEqual(expectedOutput.blocks);
        expect(convertedToDraft.entityMap).toEqual(expectedOutput.entityMap);
        expect(convertedToDraft.documentStyle).toEqual(expectedOutput.documentStyle);
      });
    });
  });
};
